module.exports = __webpack_public_path__ + "assets/tb_zendesk.png";